import _mergeJSXProps4 from "@vue/babel-helper-vue-jsx-merge-props";
import _mergeJSXProps3 from "@vue/babel-helper-vue-jsx-merge-props";
import _mergeJSXProps2 from "@vue/babel-helper-vue-jsx-merge-props";
import _mergeJSXProps from "@vue/babel-helper-vue-jsx-merge-props";

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { isFunction, isDef } from '@cloud-sn/v-utils';
import { VSlider, VSliderRange } from '@cloud-sn/v-slider';
import { buildComponentName } from '../utils';
import Tooltip from '../tooltip';
var DELAY_TIME = 60 * 60 * 1000;
export default {
  name: buildComponentName('Slider'),
  props: _objectSpread({}, VSlider.props, {}, VSliderRange.props, {
    prefixCls: {
      type: String,
      default: 'ux-slider'
    },
    value: {
      type: [Number, Array],
      default: 0
    },
    tooltipPrefixCls: {
      type: String,
      default: 'ux-tooltip'
    },
    range: {
      type: Boolean,
      default: false
    },
    tipFormatter: {
      type: [Function, Boolean],
      default: function _default(val) {
        return val.toString();
      }
    },
    tabindex: {
      type: [Number, Array],
      default: 0
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 100
    },
    step: {
      type: [Number, Boolean],
      default: 1
    },
    marks: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    included: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    dots: {
      type: Boolean,
      default: false
    },
    vertical: {
      type: Boolean,
      default: false
    },
    handleStyle: {
      type: [Array, Object],
      default: function _default() {
        return {};
      }
    },
    trackStyle: {
      type: [Array, Object],
      default: function _default() {
        return {};
      }
    },
    railStyle: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    dotStyle: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    activeDotStyle: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    autofocus: {
      type: Boolean,
      default: false
    }
  }),
  data: function data() {
    return {
      visibles: {}
    };
  },
  computed: {
    bindProps: function bindProps() {
      var $props = this.$props,
          handleWithTooltip = this.handleWithTooltip,
          range = this.range,
          value = this.value,
          tabindex = this.tabindex,
          count = this.count,
          allowCross = this.allowCross,
          pushable = this.pushable;
      var r = null;

      if (range) {
        r = {
          value: Array.isArray(value) ? value : [value, value],
          tabindex: Array.isArray(tabindex) ? tabindex : [tabindex, tabindex],
          count: count,
          allowCross: allowCross,
          pushable: pushable
        };
      } else {
        r = {
          value: Array.isArray(value) ? value[0] : value,
          tabindex: Array.isArray(tabindex) ? tabindex[0] : tabindex
        };
      }

      return _objectSpread({}, $props, {
        handle: handleWithTooltip
      }, r);
    }
  },
  methods: {
    toggleTooltipVisible: function toggleTooltipVisible(index, visible) {
      var visibles = this.visibles;
      this.visibles = _objectSpread({}, visibles, _defineProperty({}, index, visible));
    },
    handleWithTooltip: function handleWithTooltip(_ref) {
      var className = _ref.className,
          style = _ref.style,
          ref = _ref.ref,
          refInFor = _ref.refInFor,
          index = _ref.index,
          dragging = _ref.dragging,
          value = _ref.value,
          on = _ref.on,
          params = _objectWithoutProperties(_ref, ["className", "style", "ref", "refInFor", "index", "dragging", "value", "on"]);

      var h = this.$createElement;
      var tipFormatter = this.tipFormatter,
          tooltipPrefixCls = this.tooltipPrefixCls,
          tooltipRef = this.$refs.tooltipRef,
          visibles = this.visibles,
          toggleTooltipVisible = this.toggleTooltipVisible;
      var nativeOn = {
        mouseenter: function mouseenter() {
          toggleTooltipVisible(index, true);
        },
        mouseleave: function mouseleave() {
          toggleTooltipVisible(index, false);
        }
      };
      var visible = false;
      var tooltipProps = {
        // // hack!!下面两个设置的作用等于不使用tooltip内部控制显示和隐藏的逻辑,完全手工控制显示和隐藏
        // mouseEnterDelay: DELAY_TIME,
        // mouseLeaveDelay: DELAY_TIME,
        // 手工控制tooltip 显示/隐藏
        trigger: 'none'
      };

      if (isFunction(tipFormatter)) {
        visible = visibles[index] || dragging;
        tooltipProps = _objectSpread({}, tooltipProps, {
          prefixCls: tooltipPrefixCls,
          placement: 'top',
          content: tipFormatter(isDef(value) ? value : '', index),
          transitionName: 'zoom-down'
        });

        if (tooltipRef && tooltipRef[index]) {
          tooltipRef[index].setOpen(visible);
          tooltipRef[index].updateTooltipAlign();
        }
      }

      tooltipProps.visible = visible;

      var attrs = _objectSpread({}, params, {
        value: value
      });

      return h(Tooltip, _mergeJSXProps2([{}, {
        props: tooltipProps,
        ref: 'tooltipRef',
        refInFor: true
      }]), [h(VSlider.Handle, _mergeJSXProps([{}, {
        class: className,
        style: style,
        attrs: attrs,
        ref: ref,
        refInFor: refInFor,
        nativeOn: nativeOn,
        on: on
      }]))]);
    }
  },
  render: function render() {
    var h = arguments[0];
    var range = this.range,
        $listeners = this.$listeners,
        bindProps = this.bindProps,
        $attrs = this.$attrs;
    var sliderAttrs = {
      props: bindProps,
      attrs: $attrs,
      on: $listeners
    };
    return range ? h(VSliderRange, _mergeJSXProps3([{}, sliderAttrs])) : h(VSlider, _mergeJSXProps4([{}, sliderAttrs]));
  }
};